import { environment as BASE_ENVIRONMENT } from './environment.base';

export const environment = {
  ...BASE_ENVIRONMENT,

  production: false,
  sbClientLogin: 'tim-pro-101111119-sb-tim-feature2.apps.dev.ocp.21c.ads'
};
